import styled from "styled-components";
import { Container, Segment } from "semantic-ui-react";

export const SemanticContainer = styled.div`
  padding: 1rem;
`;

export const SemanticSegment = styled(Segment)`
  text-align: center;
  position: relative;
  bottom: 0;
`;
